// import React from "react";
// import { useState, useEffect } from "react";
// import axios from "axios";

// const BenfitsOfStrikeAndSports = () => {
//   const [benefits, setBenefits] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const allBenefits = () => {
//     setLoading(true);
//     let config = {
//       method: "get",
//       maxBodyLength: Infinity,
//       url: `${process.env.REACT_APP_API_URL}/benefit/get-all-benefits`,
//       headers: {},
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log(JSON.stringify(response.data));
//         setBenefits([...response.data.data].reverse());
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.log(error);
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     allBenefits();
//   }, []);

//   if (loading) {
//     return <BenefitsSkeleton />;
//   }
//   return (
//     <section className="w-full relative pb-20 font-heading flex flex-col items-center px-4 md:px-8 lg:px-12 bg-[#0B0D14] bg-[radial-gradient(circle_at_15%_35%,#F53A5F40,transparent_30%),radial-gradient(circle_at_20%_99%,#F53A5F40,transparent_15%),radial-gradient(circle_at_85%_50%,#F53A5F40,transparent_30%)]">
//       {/* Title */}
//       <h2 className="text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-relaxed tracking-wide font-bold text-center my-10 sm:my-12 md:my-14 lg:my-16">
//         <span className="hidden sm:block"> BENEFITS OF STRIKES & SHOTS</span>
//         <p className="sm:hidden flex flex-col">
//           <span>BENEFITS OF</span>
//           <span>STRIKES & SHOTS</span>
//         </p>
//       </h2>

//       <div className="absolute inset-0  bg-gradient-to-r -z-[1] blur-lg bg-black/40"></div>

//       {/* Cards */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6  w-full">
//         {benefits.map((item, idx) => (
//           <div
//             key={idx}
//             className="bg-gray-600/10 rounded-2xl p-6 py-10 sm:py-14 md:py-16 lg:py-20 flex flex-col hover:scale-[102%] md:hover:scale-105 transition-transform duration-300 shadow-md hover:shadow-2xl"
//           >
//             {/* Circle Image */}
//             <img
//               src={item.image}
//               alt={item.title}
//               className="w-40 h-40 mx-auto md:mx-0 object-cover rounded-full mb-6"
//             />
//             {/* Title */}
//             <p className="text-white text-center md:text-left font-semibold text-2xl leading-10 tracking-wide align-middle">
//               {item.title}
//             </p>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default BenfitsOfStrikeAndSports;

// const BenefitsSkeleton = () => {
//   return (
//     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 px-4 md:px-8 lg:px-12">
//       {[1, 2, 3, 4].map((i) => (
//         <div
//           key={i}
//           className="bg-gradient-to-br from-[#2A0A35] to-[#0A1F3D] p-6 rounded-2xl shadow-lg text-center flex flex-col items-center animate-pulse"
//         >
//           {/* Circular image skeleton */}
//           <div className="w-28 h-28 rounded-full bg-gray-700 mb-4"></div>

//           {/* Text line skeleton */}
//           <div className="h-5 w-3/4 bg-gray-700 rounded mb-2"></div>
//           <div className="h-5 w-1/2 bg-gray-700 rounded"></div>
//         </div>
//       ))}
//     </div>
//   );
// };

import React from "react";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { ChevronLeft, ChevronRight } from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";

const BenfitsOfStrikeAndSports = () => {
  const [benefits, setBenefits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const autoPlayRef = useRef(null);

  const allBenefits = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/benefit/get-all-benefits`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setBenefits([...response.data.data].reverse());
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    AOS.init({ duration: 800, once: false, easing: "ease-out" });
    allBenefits();
  }, []);

  // Auto-scroll effect
  useEffect(() => {
    if (isAutoPlaying && benefits.length > 4) {
      autoPlayRef.current = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % benefits.length);
      }, 3000); // Change slide every 3 seconds
    }

    return () => {
      if (autoPlayRef.current) {
        clearInterval(autoPlayRef.current);
      }
    };
  }, [isAutoPlaying, benefits.length]);

  const handlePrev = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) =>
      prev + 1 < benefits.length - 3 ? prev + 1 : prev
    );
  };

  const handleMouseEnter = () => {
    setIsAutoPlaying(false);
  };

  const handleMouseLeave = () => {
    if (benefits.length > 4) {
      setIsAutoPlaying(true);
    }
  };

  if (loading) {
    return <BenefitsSkeleton />;
  }

  // If 4 or fewer items, display static grid
  if (benefits.length <= 4) {
    return (
      <section className="w-full relative pb-20 font-heading flex flex-col items-center px-4 md:px-8 lg:px-12 bg-[#0B0D14] bg-[radial-gradient(circle_at_15%_35%,#F53A5F40,transparent_30%),radial-gradient(circle_at_20%_99%,#F53A5F40,transparent_15%),radial-gradient(circle_at_85%_50%,#F53A5F40,transparent_30%)]">
        <h2 className="text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-relaxed tracking-wide font-bold text-center my-10 sm:my-12 md:my-14 lg:my-16">
          <span className="hidden sm:block" data-aos="zoom-in">
            {" "}
            BENEFITS OF STRIKES & SHOTS
          </span>
          <p className="sm:hidden flex flex-col" data-aos="zoom-in">
            <span>BENEFITS OF</span>
            <span>STRIKES & SHOTS</span>
          </p>
        </h2>

        <div className="absolute inset-0 bg-gradient-to-r -z-[1] blur-lg bg-black/40"></div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 w-full">
          {benefits.map((item, idx) => (
            <BenefitCard key={idx} item={item} />
          ))}
        </div>
      </section>
    );
  }

  // If more than 4 items, display carousel
  return (
    <section className="w-full relative pb-20 font-heading flex flex-col items-center px-4 md:px-8 lg:px-12 bg-[#0B0D14] bg-[radial-gradient(circle_at_15%_35%,#F53A5F40,transparent_30%),radial-gradient(circle_at_20%_99%,#F53A5F40,transparent_15%),radial-gradient(circle_at_85%_50%,#F53A5F40,transparent_30%)]">
      <h2 className="text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-relaxed tracking-wide font-bold text-center my-10 sm:my-12 md:my-14 lg:my-16">
        <span className="hidden sm:block"> BENEFITS OF STRIKES & SHOTS</span>
        <p className="sm:hidden flex flex-col">
          <span>BENEFITS OF</span>
          <span>STRIKES & SHOTS</span>
        </p>
      </h2>

      <div className="absolute inset-0 bg-gradient-to-r -z-[1] blur-lg bg-black/40"></div>

      {/* Carousel Container */}
      <div className="relative w-full overflow-hidden">
        {/* Navigation Buttons */}
        <button
          onClick={handlePrev}
          className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/10 hover:bg-white/20 text-white p-2 rounded-full backdrop-blur-sm transition-all duration-300"
          aria-label="Previous"
        >
          <ChevronLeft size={24} />
        </button>

        <button
          onClick={handleNext}
          className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/10 hover:bg-white/20 text-white p-2 rounded-full backdrop-blur-sm transition-all duration-300"
          aria-label="Next"
        >
          <ChevronRight size={24} />
        </button>

        {/* Carousel Track */}
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{
            transform: `translateX(-${currentIndex * (100 / 4)}%)`,
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {benefits.map((item, idx) => (
            <div
              key={idx}
              className="flex-shrink-0 px-3"
              style={{ width: "25%" }}
            >
              <BenefitCard item={item} />
            </div>
          ))}
        </div>
      </div>

      {/* Dots Indicator */}
      {/* <div className="flex gap-2 mt-8">
        {benefits.map((_, idx) => (
          <button
            key={idx}
            onClick={() => {
              setIsAutoPlaying(false);
              setCurrentIndex(idx);
            }}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              idx === currentIndex ? "bg-white w-8" : "bg-white/40"
            }`}
            aria-label={`Go to slide ${idx + 1}`}
          />
        ))}
      </div> */}
    </section>
  );
};

// Separate BenefitCard component for reusability
const BenefitCard = ({ item }) => (
  <div
    className="bg-gray-600/10 rounded-2xl p-6 py-10 sm:py-14 md:py-16 lg:py-20 flex flex-col hover:scale-[102%] md:hover:scale-105 transition-transform duration-300 shadow-md hover:shadow-2xl h-full"
    data-aos="zoom-in"
  >
    <img
      src={item.image}
      alt={item.title}
      className="w-40 h-40 mx-auto md:mx-0 object-cover rounded-full mb-6"
    />
    <p className="text-white text-center md:text-left font-semibold text-2xl leading-10 tracking-wide align-middle">
      {item.title}
    </p>
  </div>
);

export default BenfitsOfStrikeAndSports;

const BenefitsSkeleton = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 px-4 md:px-8 lg:px-12">
      {[1, 2, 3, 4].map((i) => (
        <div
          key={i}
          className="bg-gradient-to-br from-[#2A0A35] to-[#0A1F3D] p-6 rounded-2xl shadow-lg text-center flex flex-col items-center animate-pulse"
        >
          <div className="w-28 h-28 rounded-full bg-gray-700 mb-4"></div>
          <div className="h-5 w-3/4 bg-gray-700 rounded mb-2"></div>
          <div className="h-5 w-1/2 bg-gray-700 rounded"></div>
        </div>
      ))}
    </div>
  );
};
